import Box from '@material-ui/core/Box'
import { sessionChipStatus, sessionChipVariant } from 'lib/sessions/utils'
import { useStyles } from './item-styles'

export default function SessionStatusChip({
  isCanceled,
  isPaid,
  isLessonCredit,
}) {
  const chipVariant = sessionChipVariant({ isCanceled, isPaid, isLessonCredit })
  const classes = useStyles({ chipVariant })
  const label = sessionChipStatus({ isCanceled, isPaid, isLessonCredit })

  return (
    <Box
      component="span"
      className={classes.statusChip}
      data-testid="session-status-chip"
    >
      {label}
    </Box>
  )
}
